// Inspections const
export const QUEUE_STATUS_NOT_READY_FOR_REVIEW = "NOT_READY_FOR_REVIEW"
export const QUEUE_STATUS_READY_FOR_REVIEW = "READY_FOR_REVIEW"
export const QUEUE_STATUS_UNDER_REVIEW = "UNDER_REVIEW"
export const QUEUE_STATUS_REVIEWED = "REVIEWED"

export const DECISION_PUBLISH = "PUBLISH"
export const DECISION_UNSELLABLE = "UNSELLABLE"
export const DECISION_EXCEPTION = "EXCEPTION"

export const COMMERCE_STATUS_UNSOLD = "UNSOLD"
export const COMMERCE_STATUS_SOLD = "SOLD"
export const COMMERCE_STATUS_SOLD_APTDECO = "SOLD_APTDECO"

// Non-publish decision reasons
// Unsellable
export const MISSING_PARTS = "MISSING_PARTS"
export const DAMAGED_REPAIRABLE = "DAMAGED_REPAIRABLE"
export const DAMAGED_UNREPAIRABLE = "DAMAGED_UNREPAIRABLE"
// Exception
export const MISSING_INSPECTION_PHOTOS = "MISSING_INSPECTION_PHOTOS"
export const POOR_INSPECTION_PHOTOS = "POOR_INSPECTION_PHOTOS"
export const NO_MATCH = "NO_MATCH"
// Both
export const OTHER = "OTHER"


export const GRADE_GOOD = "GOOD"
export const GRADE_BETTER = "BETTER"
export const GRADE_BEST = "BEST"
export const GRADE_OVERSTOCK = "OVERSTOCK"

export const DONATE = "DONATE";
export const DISPOSE = "DISPOSE";
export const LIQUIDATE = 'LIQUIDATE';

export const AVAILABLE_MARKETPLACE_LISTINGS = [  
  { 
    name: 'floorfound-storefront',
    publicName: 'FloorFound Storefront',
    channelId: '2b3c39ea-f908-4d1d-938e-475d82e66b49',
    enabled: true,
    disableCheckbox: true, // temporary until disabling storefronts in app backend is supported
    isPriceAdjustable: false,
  },
  { 
    name: 'branded-storefront',
    publicName: 'Branded Storefront',
    channelId: 'f304d719-2078-43f0-b103-b40015976734',
    enabled: true,
    disableCheckbox: true, // temporary until disabling storefronts in app backend is supported
    isPriceAdjustable: false,
  },
  { 
    name: 'aptdeco',
    publicName: 'AptDeco',
    channelId: 'c0eba07e-6b22-4cd0-a0e9-fb4bc9f58796',
    enabled: false,
    isPriceAdjustable: true,
  },
  { 
    name: 'chairish',
    publicName: 'Chairish',
    channelId: '1aace9c3-6db0-4d99-941a-b5fea4945a3a',
    enabled: false,
    isPriceAdjustable: true,
  },
 ];

  export const CHANNEL_ITEMS = [
    {
      name: 'chairish-category',
      publicName: 'Category',
      required: true,
      channelId: '1aace9c3-6db0-4d99-941a-b5fea4945a3a',
      type: 'select',
      options: [ 
        'Accent Chairs',
        'Accessories',
        'Bar + Counter Stools',
        'Bar Furniture',
        'Beds',
        'Benches',
        'Bookcases + Shelving',
        'Buffet Tables + Sideboards',
        'Coffee Tables',
        'Console Tables',
        'Desks',
        'Dining Chairs',
        'Dining Tables',
        'Dressers + Chests',
        'Filing Cabinets + Credenzas',
        'Headboards',
        'Lighting',
        'Mirrors',
        'Nightstands',
        'Office chairs',
        'Ottomans',
        'Outdoor Seating',
        'Outdoor Tables',
        'Sectionals',
        'Side + End Tables',
        'Sofas',
      ],
    },
    {
      name: 'chairish-material',
      publicName: 'Material',
      required: true,
      channelId: '1aace9c3-6db0-4d99-941a-b5fea4945a3a',
      type: 'select', 
      options: [
        'Fabric',
        'Leather',
        'Lucite',
        'Metal',
        'Plastic',
        'Vinyl',
        'Wood',
      ]
    },
    {
      name: 'chairish-color',
      publicName: 'Dominant Color',
      required: true,
      channelId: '1aace9c3-6db0-4d99-941a-b5fea4945a3a',
      type: 'select',
      options: [
        'Alabaster',
        'Almond',
        'Amber',
        'Amethyst',
        'Antique White',
        'Apricot',
        'Aqua',
        'Army Green',
        'Asparagus',
        'Auburn',
        'Avocado',
        'Baby Blue',
        'Beige',
        'Black',
        'Blue',
        'Blush',
        'Bottle Green',
        'Brass',
        'Brick Red',
        'Bright Green',
        'Bright Pink',
        'Bronze',
        'Brown',
        'Bubble Gum',
        'Burgundy',
        'Burnt Orange',
        'Burnt Umber',
        'Camel',
        'Canary Yellow',
        'Celadon',
        'Cerise',
        'Cerulean',
        'Champagne',
        'Charcoal',
        'Chartreuse',
        'Chestnut',
        'Chocolate',
        'Chrome',
        'Cinnamon',
        'Coffee',
        'Copper',
        'Cornflower Blue',
        'Cream',
        'Dark Gray',
        'Dark Green',
        'Dark Pink',
        'Dove Gray',
        'Ebony',
        'Ecru',
        'Eggplant',
        'Eggshell',
        'Electric Yellow',
        'Emerald',
        'Forest Green',
        'Gold',
        'Goldenrod',
        'Gray',
        'Green',
        'Greige',
        'Hot Pink',
        'Ink Blue',
        'Ivory',
        'Jade',
        'Kelly Green',
        'Khaki',
        'Lavender',
        'Light Gray',
        'Light Green',
        'Light Pink',
        'Light Yellow',
        'Lime',
        'Linen',
        'Magenta',
        'Maroon',
        'Mauve',
        'Mint',
        'Mustard',
        'Navy Blue',
        'Neon Green',
        'Off-white',
        'Olive',
        'Onyx',
        'Orange',
        'Oxblood Red',
        'Oyster Gray',
        'Peach',
        'Persimmon',
        'Pink',
        'Pistachio',
        'Platinum',
        'Pumpkin',
        'Purple',
        'Raspberry Pink',
        'Raspberry Red',
        'Red',
        `Robin's Egg Blue`,
        'Rose',
        'Royal Blue',
        'Ruby Red',
        'Saffron',
        'Salmon',
        'Sand',
        'Scarlet',
        'Sienna',
        'Silver',
        'Sky Blue',
        'Slate Gray',
        'Stone Gray',
        'Tan',
        'Tangerine',
        'Taupe',
        'Teal',
        'Terra Cotta',
        'Tiffany Blue',
        'Transparent',
        'Turquoise',
        'Vanilla',
        'Verdigris',
        'Violet',
        'White',
        'Wine',
        'Yellow',
      ]
    },
    {
      name: 'chairish-has-imperfections',
      publicName: 'Has Imperfections?',
      required: true,
      channelId: '1aace9c3-6db0-4d99-941a-b5fea4945a3a',
      type: 'select',
      options: [
        'No Imperfections',
        'Some Imperfections',
        'Needs Restoration',
      ]
    },
    {
      name: 'chairish-arrange-shipping',
      publicName: 'Would you like Chairish to arrange shipping?',
      required: true,
      channelId: '1aace9c3-6db0-4d99-941a-b5fea4945a3a',
      type: 'boolean',
      value: 'false',
    },
    {
      name: 'chairish-parcelable',
      publicName: 'Parcelable',
      required: true,
      channelId: '1aace9c3-6db0-4d99-941a-b5fea4945a3a',
      type: 'boolean',
      value: 'false',
    },
    {
      name: 'chairish-local-pickup',
      publicName: 'Allow local pickup?',
      required: true,
      channelId: '1aace9c3-6db0-4d99-941a-b5fea4945a3a',
      type: 'boolean',
      value: 'true',
    },
    {
      name: 'chairish-shipping-cost',
      publicName: 'Shipping Cost',
      required: false,
      channelId: '1aace9c3-6db0-4d99-941a-b5fea4945a3a',
      type: 'currency',
    },
  ];